import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import {lastValueFrom, Subject} from 'rxjs';
import { Item as dxListItem, ItemClickEvent } from 'devextreme/ui/list';

import { NextPimField } from 'app/Model/Catalog/NextPimField';
import { TemplateService } from 'app/Services/template.service';
import { TemplateItem } from 'app/Model/Catalog/TemplateItem';
import { comparePimFields, fillLastKey, isNextPimField, parsePimField } from 'app/Services/templateItemHelpers';
import { TemplateItemTemplate } from '../../Model/Catalog/TemplateItemTemplate';
import {TemplateFieldsService} from "../../Services/templateFields.service";
import {LoginService} from "../../Services/login.service";

@Component({
  selector: 'np-advanced-template-defaultfield',
  templateUrl: './advanced-template-defaultfield.component.html',
})
export class AdvancedTemplateDefaultFieldComponent implements OnInit {
  @Input() templateItem: TemplateItem;
  @Input() fieldList: TemplateItemTemplate[] = [];
  @Output() onUpdate = new EventEmitter<void>();

  get pimField() {
    if (!this.templateItem.pimFields || this.templateItem.pimFields.length === 0) {
      this.templateItem.pimFields = [new NextPimField()];
    }
    return this.templateItem.pimFields[0];
  }

  constructor(private templateService: TemplateService, private fieldService: TemplateFieldsService, private loginService: LoginService) {
  }

  ngOnInit() {
    this.pimField.systemKey = '-1';
    this.pimField.elementKey = '-1';
  }

  getFieldDisplayExpr(item: TemplateItemTemplate) {
    return item?.text === item?.field ? item?.field ?? '' : `${item.text} (${item.field})`;
  }

  async update() {
    const { field, systemKey, elementKey } = this.pimField;
    const parsedKey = parsePimField(this.templateItem.key);
    if (parsedKey !== null && (comparePimFields(parsedKey, this.pimField) || !isNextPimField(parsedKey.field))) {
      this.onUpdate.emit();
      return;
    }
    let headline = await lastValueFrom(this.templateService.getHeadline(field, elementKey, systemKey, this.loginService.currentCustomer.id));
    fillLastKey(this.templateItem, headline.value);
    this.onUpdate.emit();
  }
}
